export interface ITypography {
  fonts: {
    primary: string;
  };
  rootFontSize: string;
  sizes: {
    extraLarge: string;
    extraSmall: string;
    jumbo: string;
    large: string;
    medium: string;
    small: string;
  };
  weights: {
    bold: string;
    light: string;
    medium: string;
    regular: string;
  };
}
export const typography = {
  fonts: {
    primary: 'Quicksand'
  },
  rootFontSize: '16px',
  sizes: {
    extraExtraExtraLarge: '1.75rem',
    // 28px
    extraExtraLarge: '1.5rem',
    // 24px
    extraLarge: '1.3125rem',
    // 21px
    extraSmall: '0.875rem',
    // 14px
    hyperSmall: '0.75rem',
    // 12px
    jumbo: '2rem',
    // 32px
    large: '1.125rem',
    // 18px
    medium: '1.143rem',
    // 18.30px ?
    small: '1rem' // 16px
  },
  weights: {
    bold: '700',
    light: '300',
    medium: '500',
    regular: '400'
  },
  textStyles: {
    textBase: '1rem'
  }
};